import React from 'react';
import withTranslation from 'hoc/withTranslation';

const SettingsView = ({ translations: { settings } }) => (
  <h1 data-testid="settings-placeholder-heading">{settings.title}</h1>
);

export default withTranslation(SettingsView);